import React from 'react';
import classnames from 'classnames';
import Config from 'configuration';
import { Link } from 'react-router-dom';

type Props = { className?: string }

export default function FooterContent(props: Props) {
  return (
    <div className={
      classnames(
        'footer-content',
        props.className,
      )}
    >
      <div className="">
        <p>
          ©
          {' '}
          <a href="http://www.failbettergames.com/">Failbetter Games</a>
          {' '}
          2010–2019
          {' '}
          <span style={{ fontWeight: 'bold', marginLeft: '1em' }}>
            Version
            {' '}
            {Config.version}
          </span>
        </p>
      </div>
      <div className="">
        <ul className="list--horizontal">
          <li className="list-item--separated"><a href="/help">Help</a></li>
          <li className="list-item--separated"><a href="http://www.twitter.com/failbettergames">FBG on Twitter</a></li>
          <li className="list-item--separated"><Link to="/privacy">Privacy</Link></li>
          <li className="list-item--separated"><Link to="/terms">Terms</Link></li>
        </ul>
      </div>
    </div>
  );
}